<script>
import CourseSubjectsComponent from '../../features/boxes/CourseSubjectsComponent';
import CourseActivitiesView from './CourseActivitiesView';

export default {
  components: {
    'course-activities-view': CourseActivitiesView,
  },
  extends: CourseSubjectsComponent,
};
</script>

<template>
  <div class="course_subjects_wrapper">
    <el-collapse class="course_subjects_collapse">
      <el-collapse-item
        v-for="(subject, subjectIndex) in orderSubjects(section.courseSubjects)"
        :key="subjectIndex"
        :name="subjectIndex"
      >
        <template #title>
          <div class="subject_title_bar">
            <div class="subject_title_left">
              <span class="subject_icon_badge">
                <i class="uil uil-book-alt" />
              </span>
              <span class="subject_name">{{ subject.title }}</span>
            </div>
            <div class="subject_title_right">
              <span class="subject_count_chip">
                <i class="uil uil-file-alt" /> {{ subject.getTotalActivities() }} Actividades
              </span>
            </div>
          </div>
        </template>
        <course-activities-view :course-subject="subject" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
